import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/projectMessage";

export default {
    /** 某项目消息分页（首条+回复，按时间升序） */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 某话题完整回复链 */
    queryThread: (rootId) => axios.get({url: `${PREFIX_URI}/queryThread`, data: {rootId: rootId}}),
    /** 发布消息/回复 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除消息 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
};
